import { render, staticRenderFns } from "./DocumentWithSectionsNewOrEdit.vue?vue&type=template&id=0bc09651&scoped=true"
import script from "./DocumentWithSectionsNewOrEdit.vue?vue&type=script&lang=js"
export * from "./DocumentWithSectionsNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./DocumentWithSectionsNewOrEdit.vue?vue&type=style&index=0&id=0bc09651&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc09651",
  null
  
)

export default component.exports